import React from "react";
import { MapPin, Mail, Phone } from "lucide-react";
import { motion } from "framer-motion";

const contactItems = [
  { icon: MapPin, text: "Konya, Türkiye" },
  { icon: Mail, text: "iletisim@kapsul.org.tr" },
  { icon: Phone, text: "+90 (332) 205 39 81" },
];

export const LocationSection: React.FC = () => {
  return (
    <section id="location" className="section-shell bg-[var(--bg-secondary)]">
      <div className="max-w-7xl mx-auto">

        <div className="mb-14 text-center">
          <h2 className="text-4xl sm:text-5xl font-black text-[var(--text-primary)] mb-4">
            Konum
          </h2>
          <div className="w-24 h-1 mx-auto rounded-full bg-[#73E03A]" />
          <p className="mt-4 text-[var(--text-secondary)] text-base sm:text-lg">
            Hackathon etkinliği, Konya'nın teknoloji ve girişimcilik ekosisteminin merkezinde yer alan Kapsül Teknoloji Platformu'nda gerçekleştirilecektir.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ type: "spring", stiffness: 180, damping: 18 }}
          className="kapsul-card overflow-hidden p-0 w-full h-[420px] mb-6"
          style={{ borderColor: "rgba(115,224,58,0.35)" }}
        >
          <div className="h-1.5 bg-[#73E03A] w-full" />
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3132.274548913998!2d32.485035!3d37.873501!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d08507521b7681%3A0xa28592fb726c0101!2sKaps%C3%BCl%20Teknoloji%20Platformu!5e0!3m2!1str!2str!4v999999999"
            className="w-full"
            style={{ border: 0, height: "calc(100% - 6px)" }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={{ y: -6, scale: 1.02 }}
            viewport={{ once: true }}
            transition={{ type: "spring", stiffness: 220, damping: 18 }}
            className="kapsul-card relative overflow-hidden p-5 lg:col-span-1"
            style={{ borderColor: "rgba(115,224,58,0.35)" }}
          >
            <div className="absolute inset-x-0 top-0 h-1.5 bg-[#73E03A]" />
            <MapPin className="w-5 h-5 text-[#57B92B] mb-2" />
            <p className="font-black text-sm text-[var(--text-primary)] mb-1">
              Kapsül Teknoloji Platformu
            </p>
            <p className="text-xs text-[var(--text-secondary)] leading-relaxed">
              Zindankale Yerleşkesi, Konya
            </p>
          </motion.div>

          {contactItems.map((item, idx) => (
            <motion.div
              key={item.text}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ y: -6, scale: 1.02 }}
              viewport={{ once: true }}
              transition={{ delay: (idx + 1) * 0.08, type: "spring", stiffness: 220, damping: 18 }}
              className="kapsul-card p-5 flex items-center gap-3"
              style={{ borderColor: "rgba(115,224,58,0.35)" }}
            >
              <item.icon className="w-5 h-5 text-[#57B92B] flex-shrink-0" />
              <span className="text-sm font-medium text-[var(--text-primary)] break-all">{item.text}</span>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};